import React, { useEffect, useMemo, useState } from 'react';
import { Card, Select, Button, Space, Typography, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import request from '../../../utils/request';

const { Title, Text } = Typography;
const { Option } = Select as any;

type Customer = {
  id: number;
  username: string;
  profile?: {
    customer_code?: string;
    company_name?: string;
  };
};

const SubAccountEntry: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState<number | undefined>(undefined);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      // 拉取较大分页，确保可选范围充足；后续可改为服务端搜索+分页
      const res = await request.get('/api/v1/users/', {
        params: { role: 'customer', sub_role: 'main_account', page: 1, page_size: 1000, ordering: 'username' }
      });
      const raw = res.data?.results ?? res.data ?? [];
      const list: Customer[] = Array.isArray(raw) ? raw : [];
      setCustomers(list);
    } catch (e: any) {
      message.error(e?.response?.data?.detail || '获取客户列表失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const options = useMemo(() => {
    return (customers || []).map(c => {
      const code = c.profile?.customer_code || '';
      const company = c.profile?.company_name || '';
      const label = [code, company || c.username].filter(Boolean).join(' - ');
      return { value: c.id, label };
    });
  }, [customers]);

  const handleEnter = () => {
    if (!selectedCustomerId) {
      message.warning('请先选择客户');
      return;
    }
    navigate(`/dashboard/admin/customers/${selectedCustomerId}/sub-accounts`);
  };

  return (
    <div className="p-6">
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <Title level={4} style={{ margin: 0 }}>选择客户进入子账号管理</Title>
        </div>

        <div style={{ marginBottom: 8, color: '#666' }}>
          <Text>请选择一个客户后进入子账号管理页面。可按客户代码、公司名或用户名搜索。</Text>
        </div>

        <Space size="middle" wrap>
          <Select
            showSearch
            allowClear
            placeholder="搜索并选择客户"
            style={{ minWidth: 320 }}
            loading={loading}
            filterOption={(input: string, option: any) => {
              const txt = (option?.label || '').toString().toLowerCase();
              return txt.includes(input.toLowerCase());
            }}
            options={options}
            value={selectedCustomerId}
            onChange={(v: number | undefined) => setSelectedCustomerId(v)}
          />
          <Button type="primary" onClick={handleEnter}>进入子账号管理</Button>
        </Space>
      </Card>
    </div>
  );
};

export default SubAccountEntry;


